import sideMenu from "../../common/layout/sidenav/sidenav.menu";
import gmb from "../../config/constantsGMB";
import * as UnitHelper from "../unit/unit.helper";

class LoginController {
  constructor($state, Auth, Restangular, Toast, $mdDialog, $interval) {
    this.$state = $state;
    this.$interval = $interval;
    this.$mdDialog = $mdDialog;
    this.Auth = Auth;
    this.Toast = Toast;
    this.thisYear = moment().format("YYYY");
    this.Login = Restangular.service("admin/login");
    this.LoginGoogle = Restangular.service("admin/login/google");
    this.setToken();
  }

  async setToken() {
    await UnitHelper.setTokenToLocalStorage(this.$state.params);
    if (localStorage.getItem("id_token")) {
      this.onSignIn();
    }
  }

  loadingDialog() {
    var parentEl = angular.element(document.body);
       this.$mdDialog.show({
         parent: parentEl,
         template:
        '<div layout="row" style="width: 100px; height: 100px; text-align: center; padding-top: 23px;" layout-sm="column" layout-align="space-around">' +
        '<md-progress-circular md-mode="indeterminate" class="md-accent"></md-progress-circular>' +
        "</div>",
        controllerAs: 'ctrl'
    });
  }

  onSignIn() {
    var aToken = { token: localStorage.getItem("id_token") };
    this.loadingDialog()
    this.LoginGoogle.post(aToken)
      .then((response) => {
        this.Auth.login(response.token, response.user, false);
        let home = "unit.list";
        if (
          response.user.access_group &&
          !response.user.access_group.is_super &&
          response.user.access_group.admin_modules.length
        ) {
          let homeModule = this.Auth.getAuthorizedModules(
            response.user.access_group
          )[0];
          home = _.find(sideMenu, { title: homeModule }).home;
        }
        this.$mdDialog.hide()
        this.$state.go(home);
      })
      .catch((err) => {
        this.Auth.logout();
        this.$mdDialog.hide()
        this.loading = false;
        this.$mdDialog.show(
          this.$mdDialog
            .alert()
            .clickOutsideToClose(true)
            .title("Não autorizado")
            .textContent(
              "Olá, este é um painel administrativo do Sabin Canal Mobile, no momento este email não tem permissão para acessar este canal.\nEnvie um email para suporte@usemobile.com.br para solicitar o acesso informando o seu nome, a sua área, o seu email e uma justificativa para a inclusão do seu acesso.\nObrigado pela compreensão."
            )
            .ok("Ok")
        );
      });
  }

  oauth2SignIn() {
    const oauth2Endpoint = "https://accounts.google.com/o/oauth2/v2/auth";

    let form = document.createElement("form");
    form.setAttribute("method", "GET");
    form.setAttribute("action", oauth2Endpoint);

    const params = {
      client_id: gmb.clientId,
      redirect_uri: gmb.redirectUriGoogle,
      scope: "openid profile email",
      state: "try_sample_request",
      response_type: "id_token",
      nonce: "n-0S6_WzA2Mj",
    };

    for (let p in params) {
      let input = document.createElement("input");
      input.setAttribute("type", "hidden");
      input.setAttribute("name", p);
      input.setAttribute("value", params[p]);
      form.appendChild(input);
    }

    document.body.appendChild(form);
    form.submit();
  }

  login(form, email, password, rememberMe) {
    if (form.$valid === false) {
      console.log("invalid form");
      return;
    }

    this.loading = true;

    this.Login.post({ email, password })
      .then((response) => {
        this.Auth.login(response.token, response.user, rememberMe);
        let home = "unit.list";
        if (
          response.user.access_group &&
          !response.user.access_group.is_super &&
          response.user.access_group.admin_modules.length
        ) {
          let homeModule = this.Auth.getAuthorizedModules(
            response.user.access_group
          )[0];
          home = _.find(sideMenu, { title: homeModule }).home;
        }

        this.$state.go(home);
      })
      .catch((err) => {
        this.Auth.logout();
        this.loading = false;
        this.Toast.show("Email ou senha incorreto", { position: "top right" });
      });
  }
}

LoginController.$inject = [
  "$state",
  "Auth",
  "Restangular",
  "Toast",
  "$mdDialog",
  "$interval",
];

export default LoginController;



// WEBPACK FOOTER //
// ./client/app/components/login/login.controller.js